import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { isFeatureEnabled, hasTreatmentName } from '../utils'
import { Badge, ClockSmIcon, CriticalSmIcon } from '@paypalcorp/pp-react'
import serverData from '../utils/server-data'
import { dataPlatformConfig } from './data-privacy-data-platform'
import { pageSpec } from './fptiConstants'
const {
    userInfo = {},
    allowErasureRequest = false,
    unResolvedError = false,
  } = serverData,
  isMerchantUser = serverData.isMerchantUser,
  enabledForFaceScan =
    isFeatureEnabled('enabledForFaceScan') && !isMerchantUser,
  isInFrame = serverData.isInFrame,
  { businessType = '', isSecondaryUser = false } = userInfo

const allowedBusinessTypes = {
  INDIVIDUAL: true,
  PROPRIETORSHIP: true,
}

const isDataSectionCanbeShown = () => {
  let flag = false
  if (isMerchantUser) {
    if (!isSecondaryUser && allowedBusinessTypes[businessType.toUpperCase()]) {
      flag = true
    } else {
      return flag
    }
  } else {
    flag = true
  }
  return flag
}

const pickElmoForDatasection = () => {
  let flag = false
  flag =
    hasTreatmentName('Trmt_Manage_EDPB_Dar_Changes') ||
    hasTreatmentName('Trmt_Manage_Data_Deletion') ||
    hasTreatmentName('Trmt_Manage_Data_Correction') ||
    enabledForFaceScan
  return flag
}

const getElementExpression = () => {
  let element = null
  if (allowErasureRequest) {
    element = <Message id="privacy.deleteData.description" />
  } else if (unResolvedError) {
    element = (
      <div className="subdwsection-flex-align">
        <CriticalSmIcon color="sysColorErrorMain" size="sm" />
        <Message id="dataErasure.preventrequset.error" />
      </div>
    )
  } else {
    element = (
      <div className="subdwsection-flex-align">
        <ClockSmIcon color="sysColorWarningMain" size="sm" />
        <Message id="dataErasure.preventrequset.inprogress" />
      </div>
    )
  }
  return element
}

const dataPlatformSections = [
  {
    sectionId: 'manageyourdata',
    sectionName: <Message id="privacy.data.sectionName" />,
    badge: {
      type: 'feature',
      text: <Message id="privacy.badge.new" />,
    },
    isEnabled: isDataSectionCanbeShown(),
    domid: 'manageyourdata',
    hasElmoTreatment: pickElmoForDatasection(),
    enabledCountries: [],
    subSections: [
      {
        subSectionId: 'download_data',
        title: <Message id="privacy.downloadData.title" />,
        desc: <Message id="privacy.downloadData.description" />,
        icon: dataPlatformConfig.downloadData.icon,
        domid: 'download_data',
        featureEnabled: true, //rcs service
        hasElmoTreatment: hasTreatmentName('Trmt_Manage_EDPB_Dar_Changes'),
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/data/dar?inframe=${isInFrame}`
            : '/myaccount/privacy/data/dar',
        fptiClickData:
          pageSpec.privacy_section_download_data_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.createRequest" />,
      },
      {
        subSectionId: 'correct_data',
        title: <Message id="privacy.correctData.title" />,
        desc: <Message id="privacy.correctData.description" />,
        icon: dataPlatformConfig.correctData.icon,
        domid: 'correct_data',
        featureEnabled: true,
        hasElmoTreatment: hasTreatmentName('Trmt_Manage_Data_Correction'),
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/data/dar/correction?inframe=${isInFrame}`
            : '/myaccount/privacy/data/dar/correction',
        fptiClickData:
          pageSpec.privacy_section_correct_data_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'manage_face_scan',
        title: <Message id="privacy.faceData.title" />,
        icon: dataPlatformConfig.verificationData.icon,
        domid: 'manage_face_scan',
        featureEnabled: enabledForFaceScan,
        navigateTo: '/myaccount/privacy/data/verify/facescan',
        hasElmoTreatment: true,
        fptiClickData: pageSpec.privacy_section_manage_face_scan_link(),
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'delete_data',
        title: (
          <Message
            id={
              isMerchantUser
                ? 'privacy.merchant.deleteData.title'
                : 'privacy.deleteData.title'
            }
          />
        ),
        desc: getElementExpression(),
        icon: dataPlatformConfig.deleteData.icon,
        domid: 'delete_data',
        featureEnabled: true,
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/data/deletion?inframe=${isInFrame}`
            : '/myaccount/privacy/data/deletion',
        hasElmoTreatment: hasTreatmentName('Trmt_Manage_Data_Deletion'),
        fptiClickData:
          pageSpec.privacy_section_delete_data_link(isMerchantUser),
        action: <Message id="privacy.merchant.action.createRequest" />,
      },
    ],
  },
]

// this submodule has to retrieved from /api and will be served via serverData
dataPlatformSections[0].subSections[0].subModule = {
  subModuleId: 'data_request_history',
  title: <Message id="dar.history.header.title" />,
  desc: <Message id="dar.history.header.desc" />,
  badgeName: 'download',
  badgeFeature: 'feature',
  action: <Message id="privacy.merchant.action.view" />,
  domid: 'data_request_history',
  fptiClickData:
    pageSpec.privacy_section_data_request_history_link(isMerchantUser),
  modal: {
    name: 'dataRequestHistory',
  },
  navigateTo:
    isInFrame && isMerchantUser
      ? `/myaccount/privacy/data/dar/yourrequests?inframe=${isInFrame}`
      : '/myaccount/privacy/data/dar/yourrequests',
  enabled: () => {
    return Object.keys(serverData.darHistory).length > 0
  },
  badgeStatus: () => {
    const DARSTATUS = {
      OPEN: (
        <Badge
          type={dataPlatformConfig.downloadData.badge.open.type}
          className={dataPlatformConfig.downloadData.badge.open.className}
        >
          <Message id="dar.history.request.status.open" />
        </Badge>
      ),
      INPROGRESS: (
        <Badge
          type={dataPlatformConfig.downloadData.badge.progress.type}
          className={dataPlatformConfig.downloadData.badge.progress.className}
        >
          <Message id="dar.history.request.status.progress" />
        </Badge>
      ),

      CLOSED: (
        <Badge
          type={dataPlatformConfig.downloadData.badge.download.type}
          className={dataPlatformConfig.downloadData.badge.download.className}
        >
          <Message id="dar.history.request.status.download" />
        </Badge>
      ),
    }
    return DARSTATUS[
      Object.keys(serverData.darHistory).length > 0 &&
        serverData.darHistory[0].status
    ]
  },
}

export default dataPlatformSections
